import React from "react";
import { Zap, Clock, RefreshCw, Bot, FileText } from "lucide-react";

const PATTERNS = [
    { icon: Zap, label: "Real-Time", color: "#F59E0B" },
    { icon: Clock, label: "Schedule", color: "#8B5CF6" },
    { icon: RefreshCw, label: "Sync", color: "#3B82F6" },
    { icon: Bot, label: "AI Agent", color: "#10B981" },
    { icon: FileText, label: "Blank", color: "#6B7280" },
];

export default function WorkflowStartOverlay() {
    return (
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none z-10">
            <div className="bg-white/95 backdrop-blur-sm border border-gray-200 rounded-xl p-8 max-w-md pointer-events-auto shadow-lg">
                <h2 className="text-lg font-semibold text-gray-900 text-center mb-4">
                    What are you automating?
                </h2>
                <p className="text-sm text-gray-500 text-center mb-6">
                    Describe your workflow in the chat, or start with a pattern.
                </p>
                <div className="flex flex-wrap justify-center gap-2">
                    {PATTERNS.map((p) => (
                        <button
                            key={p.label}
                            className="flex items-center gap-1.5 px-3 py-2 bg-gray-50 hover:bg-gray-100 border border-gray-200 rounded-lg text-xs text-gray-700 transition-colors"
                        >
                            <p.icon size={14} style={{ color: p.color }} />
                            {p.label}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
}
